import { PROCESS } from '@/constants/content';

export default function Process() {
    return (
        <section id="process" className="section-pad bg-white">
            <div className="container-wl">
                <div className="max-w-3xl">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="gold-rule" />
                        <span className="overline">Our Advisory Process</span>
                    </div>
                    <h2 className="font-display-bold text-ink text-4xl lg:text-[52px] leading-[1.05] tracking-tight">
                        A clear, four-step path from <span className="italic text-gold-600">today</span> to your goals.
                    </h2>
                </div>

                <div className="mt-16 relative">
                    <div className="hidden lg:block absolute top-[44px] left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/70 to-transparent" />
                    <div className="grid lg:grid-cols-4 gap-10 lg:gap-8">
                        {PROCESS.map((p) => (
                            <div key={p.step} className="relative text-left lg:text-center">
                                <div className="lg:mx-auto inline-flex items-center justify-center w-[88px] h-[88px] rounded-full bg-white border border-hairline shadow-soft relative z-10">
                                    <span className="font-display-bold text-gold-600 text-3xl">
                                        {p.step}
                                    </span>
                                </div>
                                <h3 className="font-display-bold text-ink text-[22px] mt-6">
                                    {p.title}
                                </h3>
                                <p className="mt-3 text-[14.5px] text-ink/65 leading-relaxed max-w-xs lg:mx-auto">
                                    {p.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
